import app from 'flarum/forum/app';
import Modal from 'flarum/common/components/Modal';
import Button from 'flarum/common/components/Button';
import extractText from 'flarum/common/utils/extractText';
import { formatRemaining } from '../../common/breakState';

const KEY = 'happydigital-interaction-break.forum.break';

/**
 * The friendly "take a breather" notice, with a live countdown. Closes itself
 * when the break ends, so the user can go straight back to the composer.
 *
 * attrs: { minutes: 5 | 60, remaining: seconds left }
 */
export default class BreakModal extends Modal {
  oninit(vnode) {
    super.oninit(vnode);

    this.endsAt = Date.now() + this.attrs.remaining * 1000;
    this.left = this.secondsLeft();

    this.timer = setInterval(() => {
      this.left = this.secondsLeft();

      if (this.left <= 0) {
        this.hide();
      }

      m.redraw();
    }, 1000);
  }

  onremove(vnode) {
    super.onremove(vnode);
    clearInterval(this.timer);
  }

  secondsLeft() {
    return Math.max(0, Math.ceil((this.endsAt - Date.now()) / 1000));
  }

  className() {
    return 'BreakModal Modal--small';
  }

  title() {
    return extractText(app.translator.trans(`${KEY}.title_${this.attrs.minutes}`));
  }

  content() {
    const paragraphs = extractText(app.translator.trans(`${KEY}.body_${this.attrs.minutes}`)).split('\n\n');

    return (
      <div className="Modal-body">
        <div className="Form Form--centered">
          {paragraphs.map((text) => (
            <p className="BreakModal-text">{text}</p>
          ))}

          <p className="BreakModal-remaining">
            {app.translator.trans(`${KEY}.remaining`)}: <strong>{formatRemaining(this.left)}</strong>
          </p>

          <div className="Form-group">
            <Button className="Button Button--primary Button--block" onclick={() => this.hide()}>
              {app.translator.trans(`${KEY}.close`)}
            </Button>
          </div>
        </div>
      </div>
    );
  }
}
